.uploadWrapper,
:global(.file-upload-wrapper) {
  margin-bottom: 10px;
  > .title {
    margin-bottom: 5px;
  }
}

.horizontal {
  display: flex;
  justify-content: space-between;

  > div {
    width: 48%;
  }
}

.image,
:global(.file-upload-image) {
  border-radius: var(--radius-inner);
  margin-bottom: 10px;
  position: relative;
}

.imageInBackground,
.imageInBackgroundLoading,
:global(.file-upload-image-background),
:global(.file-upload-image-background-loading) {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: var(--radius-inner);
  padding-bottom: 56.25%;
  width: 100%;
}

.imageInBackgroundLoading,
:global(.file-upload-image-background-loading) {
  background-size: contain;
}

.file-upload {
  width: 300px;
}

.uploadWrapper input,
:global(.file-upload-wrapper) input {
  position: absolute;
  left: -9999px;
}
